// Desenha as páginas de um PDF no navegador com o pdf.js da Mozilla (copiado em public/pdfjs, sem depender de outro site).
let carregando: Promise<any> | null = null;
function pdfjs(): Promise<any> {
  if ((window as any).pdfjsLib) return Promise.resolve((window as any).pdfjsLib);
  carregando ??= new Promise((ok, erro) => {
    const s = document.createElement('script');
    s.src = '/pdfjs/pdf.min.js';
    s.onload = () => { const L = (window as any).pdfjsLib; L.GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.min.js'; ok(L); };
    s.onerror = () => { carregando = null; erro(new Error('pdf.js')); };
    document.head.appendChild(s);
  });
  return carregando;
}

export const temRenderizador = () => true;

const docs = new Map<string, Promise<any>>();
async function abrir(uri: string) {
  let d = docs.get(uri);
  if (!d) {
    // isEvalSupported: false fecha a falha conhecida de PDFs com fontes maliciosas
    d = pdfjs().then(async L => L.getDocument({ data: new Uint8Array(await (await fetch(uri)).arrayBuffer()), isEvalSupported: false }).promise);
    docs.set(uri, d);
  }
  return d;
}

const cache = new Map<string, { uri: string; w: number; h: number }>();
export async function renderizar(uri: string, pagina: number, maxLado = 1200, qualidade = 80): Promise<{ uri: string; w: number; h: number }> {
  const chave = `${uri}#${pagina}#${maxLado}#${qualidade}`;
  const c = cache.get(chave); if (c) return c;
  const doc = await abrir(uri);
  const pg = await doc.getPage(pagina + 1);
  const v1 = pg.getViewport({ scale: 1 });
  const esc = Math.min(maxLado / v1.width, maxLado / v1.height);
  const vp = pg.getViewport({ scale: esc });
  const cv = document.createElement('canvas');
  cv.width = Math.max(1, Math.round(vp.width)); cv.height = Math.max(1, Math.round(vp.height));
  const ctx = cv.getContext('2d')!;
  ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, cv.width, cv.height);
  await pg.render({ canvasContext: ctx, viewport: vp }).promise;
  const blob: Blob = await new Promise(ok => cv.toBlob(b => ok(b!), 'image/jpeg', qualidade / 100));
  const out = { uri: URL.createObjectURL(blob), w: cv.width, h: cv.height };
  cache.set(chave, out);
  return out;
}
export const esquecerRender = (uri: string) => { docs.delete(uri); for (const k of [...cache.keys()]) if (k.startsWith(uri + '#')) { URL.revokeObjectURL(cache.get(k)!.uri); cache.delete(k); } };

/** Texto que já vem dentro do PDF, página por página. */
export async function textoDasPaginas(uri: string): Promise<string[] | null> {
  const doc = await abrir(uri);
  const out: string[] = [];
  for (let i = 1; i <= doc.numPages; i++) {
    const pg = await doc.getPage(i);
    const tc = await pg.getTextContent();
    let s = '', ultY: number | null = null;
    for (const it of tc.items as any[]) {
      const y = it.transform?.[5];
      if (ultY != null && y != null && Math.abs(y - ultY) > 2) s += '\n'; else if (s && !s.endsWith(' ')) s += ' ';
      s += it.str; ultY = y;
    }
    out.push(s.trim());
  }
  return out;
}
